"use client";
import React, { useEffect, useState } from "react";
import useApi from "../../hooks/useApi";

export function FooterCmp() {
    const [time, setTime] = useState<string | null>(null);
    const { backend } = useApi();

    useEffect(() => {
        backend.timeController.timeControllerGetSystemTime().then((res: any) => {
            setTime(new Date(res.datetime).toLocaleString('cs-CZ'));
        }).catch(() => {});
    }, []);

    return (
        <footer className="hidden sm:block sticky top-[100vh] bg-bg-card border-t border-border-muted mt-8">
            <div className="max-w-6xl mx-auto px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-4">
                <a href="https://workbox.cz" target="_blank" rel="noreferrer" className="flex-shrink-0">
                    <img
                        src="https://workbox.cz/images/logo_black.png"
                        alt="Workbox"
                        className="h-6 w-auto opacity-60 hover:opacity-100 transition-opacity"
                    />
                </a>

                <div className="flex items-center gap-6 text-[13px] font-semibold text-text-muted font-nunito">
                    <a href="https://workbox.cz" className="hover:text-brand-blue transition-colors">workbox.cz</a>
                    <a href="https://workbox.cz" className="hover:text-brand-blue transition-colors">O nás</a>
                    <a href="https://tipbuddy.cz/gdpr" className="hover:text-brand-blue transition-colors">GDPR</a>
                    <a href="mailto:info@tipbuddy.cz" className="hover:text-brand-blue transition-colors">info@tipbuddy.cz</a>
                </div>

                <div className="text-[12px] text-text-muted font-nunito text-right">
                    <div>© 2026 tipbuddy.cz</div>
                    {time && <div className="opacity-60">{time}</div>}
                </div>
            </div>
        </footer>
    );
}
